function checkIfUserIsSaml(activeSubscription) {
  if (!activeSubscription || !activeSubscription.samlEnabled) {
    return false;
  }
  return activeSubscription.samlEnabled;
}

export default checkIfUserIsSaml;
